import bankActiveEmpty from './active-empty.webp';
import bankActiveFull from './active-full.webp';
import bankActiveProgress from './active-progress.webp';
import bankInactiveEmpty from './inactive-empty.webp';
import bankInactiveFull from './inactive-full.webp';

export default {
  bankActiveEmpty,
  bankActiveFull,
  bankActiveProgress,
  bankInactiveEmpty,
  bankInactiveFull,
  bankInactiveProgress: bankInactiveFull,
};
